// src/utils/timeUtils.js
import api from "../api";
import i18n from "../translation/i18";

export const checkRemainingTestTime = async ({ testId, userId, sessionKey }) => {
  const payload = { test_id: testId, user_id: userId };

  try {
    const request = {
      url: `v1/examPanel/getTimeleft`,
      method: "POST",
      headers: {
        "X-Device-Key": localStorage.getItem("identityKey"),
        "X-Session-Key": sessionKey,
      },
      data: payload,
    };

    const response = await api.postAuthTZ(request);
    // console.log(response);
    return response.data;

  } catch (error) {
    console.error("⛔ checkRemainingTestTime error:", error);

    // 🔁 Consistent error handling like SaveAndNext
    alert(i18n.t('test.sessionExpired'));

    window.location.href = "/";
    window.close(); // attempt to close test window
    throw error; // Optional: propagate if needed
  }
};
